<template>
  <section class="table-sampler-memory-vibration">
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Instrumento</label>
        <select
          type="text"
          class="form-control"
          @change="setEquipmentData('instrument')"
          v-model="model.instrument_object"
          require
        >
          <option
            v-for="instrument in instruments"
            :key="instrument.name"
            :value="instrument"
          >
            {{ instrument.name }}
          </option>
        </select>
      </d-col>
      <d-col cols="3">
        <label>N.º de série</label>
        <input
          type="text"
          class="form-control"
          placeholder="N.º de série"
          v-model="model.instrument_serie"
          disabled
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Certificado de aferição</label>
        <input
          type="text"
          class="form-control"
          placeholder="Certificado de aferição"
          v-model="model.instrument_certificate"
          disabled
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Validade</label>
        <input
          type="text"
          class="form-control"
          placeholder="Validade"
          v-model="model.instrument_validity"
          disabled
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="2">
        <label>Data</label>
        <input
          type="text"
          class="form-control"
          placeholder="Data"
          v-model="model.date"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>N. Medição</label>
        <input
          type="text"
          class="form-control"
          placeholder="N. Medição"
          v-model="model.medition"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Horário inicial</label>
        <input
          type="time"
          class="form-control"
          placeholder="Horário inicial"
          v-model="model.initial"
          required
        />
      </d-col>
      <d-col cols>
        <label>Horário final</label>
        <input
          type="time"
          class="form-control"
          placeholder="Horário final"
          v-model="model.final"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Agente
          <small class="link" @click.prevent.stop="openModalEditAgent(model.agent_id)" v-if="model.agent_id">
            Editar
          </small>
        </label>
        <autocomplete
          ref="autocomplete_agent_vibration"
          placeholder="Agente"
          :items="agents"
          item-show="name"
          :on-input="(name) => getListAgents(name, 'vibration')"
          :on-select="(agent) => setAgentData(agent)"
          showIconClear
        />
      </d-col>
      <d-col cols="3">
        <label>Tipo de vibração</label>
        <input
          type="text"
          class="form-control"
          placeholder="Tipo de vibração"
          v-model="model.vibration_type"
          disabled
          required
        />
      </d-col>
      <d-col cols="2">
        <label>Método</label>
        <input
          type="text"
          class="form-control"
          placeholder="Método"
          v-model="model.method"
          disabled
          required
        />
      </d-col>
      <d-col cols="2">
        <label>Critério</label>
        <input
          type="text"
          class="form-control"
          placeholder="Critério"
          v-model="model.criterion"
          disabled
          required
        />
      </d-col>
      <d-col cols="2">
        <label>Limite</label>
        <input
          type="text"
          class="form-control"
          placeholder="Limite"
          v-model="model.criterion_1"
          disabled
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="2">
        <label>Componente</label>
        <input
          type="text"
          class="form-control"
          placeholder="Componente"
          v-model="model.component"
          required
        />
      </d-col>
      <d-col cols="2">
        <label>Tempo de exposição</label>
        <input
          type="text"
          class="form-control"
          placeholder="Tempo de exposição"
          v-model="model.exposition_time"
          required
        />
      </d-col>
      <d-col cols>
        <label>Ciclo</label>
        <input
          type="text"
          class="form-control"
          placeholder="Ciclo"
          v-model="model.cycle"
          required
        />
      </d-col>
      <d-col cols>
        <label>Tempo amostrado</label>
        <input
          type="time"
          class="form-control"
          placeholder="Tempo amostrado"
          v-model="model.sample_time"
          required
        />
      </d-col>
      <d-col cols>
        <label>Número de repetições <small>(h)</small></label>
        <input
          type="number"
          class="form-control"
          placeholder="Número de repetições"
          v-model="model.repeat_number"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="4">
        <label>Fonte de vibração</label>
        <input
          type="text"
          class="form-control"
          placeholder="Fonte de vibração"
          v-model="model.vibration_font"
          required
        />
      </d-col>
      <d-col cols="2">
        <label>Frequência</label>
        <input
          type="text"
          class="form-control"
          placeholder="Frequência"
          v-model="model.frequency"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Marca</label>
        <input
          type="text"
          class="form-control"
          placeholder="Marca"
          v-model="model.brand"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Modelo</label>
        <input
          type="text"
          class="form-control"
          placeholder="Modelo"
          v-model="model.model"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Ano equipamento</label>
        <input
          type="text"
          class="form-control"
          placeholder="Ano equipamento"
          v-model="model.equipment_year"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Tipo do banco</label>
        <input
          type="text"
          class="form-control"
          placeholder="Tipo de banco"
          v-model="model.bank_type"
          required
        />
      </d-col>
    </d-form-row>
    <d-form-row class="m-0 mb-1">
      <d-col cols="3">
        <label>Tipo de pneu</label>
        <input
          type="text"
          class="form-control"
          placeholder="Tipo de pneu"
          v-model="model.tire_type"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Tipo de piso</label>
        <input
          type="text"
          class="form-control"
          placeholder="Tipo de piso"
          v-model="model.floor_type"
          required
        />
      </d-col>
      <d-col cols="3">
        <label>Velocidade operação</label>
        <input
          type="text"
          class="form-control"
          placeholder="Velocidade operação"
          v-model="model.operating_speed"
          required
        />
      </d-col>
    </d-form-row>

    <epi-list :list.sync="model.epis"></epi-list>

    <d-form-row class="m-0 mb-1">
      <d-col cols="12">
        <label>Observações</label>
        <textarea
          type="text"
          class="form-control"
          placeholder="Observações"
          v-model="model.observation"
          required
        />
      </d-col>
    </d-form-row>
  </section>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Autocomplete from '_shared/Autocomplete.vue';
import EquipmentMixin from '_common/mixins/EquipmentMixin';
import AgentMixin from '_common/mixins/AgentMixin';
import { VIBRATION_MEMORY, _LOAD_MODEL_, _UPDATE_SAMPLE_CRITERION_VIBRATION_ } from '../../SampleModel';
import EpiList from '../EPIList.vue';

const TypeMap = {
  instruments: 'instrumento-vibracao',
};

export default {
  name: 'Sample-Memory-Vibration',
  mixins: [EquipmentMixin, AgentMixin],
  props: {
    memory: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      model: cloneDeep(VIBRATION_MEMORY),
    };
  },
  components: {
    EpiList,
    Autocomplete,
  },
  methods: {
    ...mapActions(['setSample']),
    setModel() {
      if (this.memory) {
        this.model = this.memory;
        this.$nextTick(() => {
          this.setAutocompleteValue('autocomplete_agent_vibration', this.memory.agent);
        });
      }
    },
    setAgentData(agent) {
      this.setAutocompleteValue('autocomplete_agent_vibration', agent?.name || null);

      this.model.agent = agent?.name || null;
      this.model.agent_id = agent?.id || null;
      this.model.vibration_type = agent?.type?.name || null;
      this.model.method = agent?.method || null;
      this.model.criterion = agent?.criterion || null;
      this.model.criterion_1 = agent?.limit || null;

      Events.$emit(_UPDATE_SAMPLE_CRITERION_VIBRATION_, agent);
    },
    handleLoadModel() {
      this.setModel();
    },
  },
  mounted() {
    this.setModel();
    this.getListEquipments('instruments', TypeMap);
    Events.$on(_LOAD_MODEL_, this.handleLoadModel);
  },
  beforeDestroy() {
    Events.$off(_LOAD_MODEL_, this.handleLoadModel);
  },
  watch: {
    model: {
      handler(value) {
        this.setSample({ ...this.$store.state.sample.sample, ...{ memory_field: value } });
        this.$emit('update:memory', value);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.table-sampler-memory-vibration {
  label {
    margin-bottom: 0;
  }
}
</style>
